import * as React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material";
import { alpha } from "@mui/material";
import { useNavigate } from "react-router";
import { dashboardRoute } from "../routes/reactRoutes";
import { ReportProblemOutlined } from "@mui/icons-material";
import { t } from "i18next";

export default function NotFound(props) {
  React.useEffect(() => {
    if (props.title) document.title = props.title;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //styling
  const theme = useTheme();
  const navigate = useNavigate();
  const divStyle = {
    display: "flex",
    p: 2,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100%",
    boxSizing: "border-box",
    background: alpha(theme.palette.primary.main, 0.15),
  };

  //end styling
  const handleHomePageClick = () => {
    navigate(dashboardRoute);
  };

  return (
    <Box sx={divStyle}>
      <ReportProblemOutlined
        color="primary"
        sx={{ width: "200px", height: "200px" }}
      ></ReportProblemOutlined>
      <Typography
        sx={{
          fontSize: "5rem",
          fontWeight: 600,
          color: theme.palette.primary.main,
        }}
      >
        404
      </Typography>
      <Typography sx={{ fontSize: "2rem", color: theme.palette.primary.main }}>
        {t("notFound")}
      </Typography>
      <Typography
        sx={{ fontWeight: 400, mb: 2.5, color: theme.palette.primary.main }}
      >
        {props.content || t("pageUnavailable")}
      </Typography>
      <Button
        variant="contained"
        onClick={handleHomePageClick}
        sx={{ width: "300px", textTransform: "none", fontSize: "1.125rem" }}
      >
        {t("gohomepage")}
      </Button>
    </Box>
  );
}
